import React, { useCallback, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import TextField from 'core/components/validatedForm/TextField'
import Column from 'core/containers/Column'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import ImageUpload from '../ImageUpload'
import HintTooltip from 'core/elements/tooltip/HintTooltip'
import colors from 'core/themes/base/colors'
import { toBase64 } from '../helper'
import { defaultAppIconPath } from '../constant'

export default function CreateTemplateBasicStep({ params, getParamsUpdater }) {
  const classes = useStyles()

  const handleImageUploadChange = useCallback(
    async (file: File) => {
      try {
        const base64String = await toBase64(file)
        getParamsUpdater('icon')(base64String)
      } catch (error) {
        console.error('Failed to convert file to base64:', error)
      }
    },
    [getParamsUpdater], // dependencies used inside the callback
  )

  return (
    <>
      <Column gap={32}>
        <div>
          <Column gap={24}>
            <TextField
              id="name"
              label="Template Name"
              onChange={getParamsUpdater('name')}
              value={params?.name}
              required
            />
            <TextField
              id="description"
              label="Description"
              className={classes.subTextContainer}
              onChange={getParamsUpdater('description')}
              value={params?.description}
            />
          </Column>
        </div>
        <div className={classes.subContainer}>
          <div className={classes.iconContainer}>
            <Text variant="caption1">Upload Template Icon</Text>
            <HintTooltip message="The default icon will be used if you don’t upload a custom icon." />
          </div>

          <ImageUpload
            id="image-upload"
            fileTypes={['.jpg', '.png']}
            onChange={handleImageUploadChange}
          />
        </div>
      </Column>
    </>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  subContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    alignItems: 'center',
    gap: 8,
  },
  subTextContainer: {
    minWidth: '100%',
    '& div': {
      minHeight: 60,
    },
  },
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    background: colors.grey[50],
    padding: '12px 16px 16px 12px',
    borderRadius: theme.spacing(0.5),
    position: 'relative',
    border: `1px solid #E6E6EA`,
    gap: 8,
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
}))
